// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_ra-8";
export var editMode = "_ra-3";
export var headerRow = "_ra-a";
export var headerTitle = "_ra-b";
export var product = "_ra-1";
export var productDetails = "_ra-5";
export var productDivider = "_ra-7";
export var productImage = "_ra-2";
export var productInfo = "_ra-4";
export var productTitle = "_ra-6";
export var strikethrough = "_ra-9";
export var upsellProductsCard = "_ra-0";